/**
 * Tipos da Store de Autenticação.
 */
export const AUTH = 'auth/AUTH'
export const AUTH_LOGIN = 'auth/AUTH_LOGIN'
export const AUTH_LOGIN_GENERIC_APP = 'auth/AUTH_LOGIN_GENERIC_APP'
export const AUTH_LOGOUT = 'auth/AUTH_LOGOUT'
export const AUTH_RESET_PASSWORD = 'auth/AUTH_RESET_PASSWORD'
export const AUTH_REQUEST_RESET = 'auth/AUTH_REQUEST_RESET'

export const AUTH_ACTIVATE = 'auth/AUTH_ACTIVATE'
export const AUTH_ACTIVATE_CHECK = 'auth/AUTH_ACTIVATE_CHECK'
export const AUTH_ACTIVATE_CHECK_ALELO = 'auth/AUTH_ACTIVATE_CHECK_ALELO'
export const CHECK_DOCUMENT_ALELO = 'auth/CHECK_DOCUMENT_ALELO'
export const AUTH_ACTIVATE_VERIFY = 'auth/AUTH_ACTIVATE_VERIFY'
export const AUTH_ACTIVATE_ALELO = 'auth/AUTH_ACTIVATE_ALELO'
export const TOKEN_ALELO = 'auth/TOKEN_ALELO'

export const AUTH_CREDENTIALS = 'auth/AUTH_CREDENTIALS'

export const FLAG_GENERIC_APP = 'auth/GENERIC_FLAG'

/**
 * Tipo da Store de Configuração.
 */
export const CONFIG = 'config/CONFIG'
export const CONFIG_MAIN = 'config/CONFIG_MAIN'
export const CONFIG_SIGNIN = 'config/CONFIG_SIGNIN'
export const CONFIG_FETCH = 'config/CONFIG_FETCH'
export const CONFIG_COLORS = 'config/CONFIG_COLORS'
export const CONFIG_COMPANIES = 'config/CONFIG_COMPANIES'
export const CONFIG_COMPANY_NAME = 'config/CONFIG_COMPANY_NAME'
export const CONFIG_COMPANY_CONFIG = 'config/CONFIG_COMPANY_CONFIG'

/**
 * Tipo da Store de Cartas Vínculo.
 */
export const LETTER = 'letter/LETTER'
export const LETTERS = 'letter/LETTERS'
export const LETTER_EXCLUDE = 'letter/LETTER_EXCLUDE'
export const LETTERS_PAGINATE = 'letter/LETTERS_PAGINATE'
export const LETTERS_INCREASE = 'letter/LETTERS_INCREASE'
export const LETTERS_TOTAL = 'letter/LETTERS_TOTAL'
export const LETTER_SEND_EMAIL = 'letter/LETTER_SEND_EMAIL'
export const LETTER_VALIDATE_EMAIL = 'letter/LETTER_VALIDATE_EMAIL'

/**
 * Tipo da Store de Cashback.
 */
export const CASHBACKS = 'cashback/CASHBACKS'
export const CASHBACK_CREATE = 'cashback/CASHBACK_CREATE'
export const CASHBACK_PAGINATE = 'cashback/CASHBACK_PAGINATE'

/**
 * Tipos da Store de Categorias.
 */
export const CATEGORIES = 'category/CATEGORIES'
export const PUBLIC_CATEGORIES = 'category/PUBLIC_CATEGORIES'
export const CATEGORIES_OPTIONS = 'category/CATEGORIES_OPTIONS'
export const CATEGORIES_MENU = 'category/CATEGORIES_MENU'
export const CATEGORIES_HOME = 'category/CATEGORIES_HOME'

/**
 * Tipos da Store de Company.
 */
export const COMPANY = 'company/COMPANY'
export const COMPANY_PERMISSIONS = 'company/COMPANY_PERMISSIONS'

/**
 * Tipos da Store de Layout.
 */
export const LAYOUT_CLOSE = 'layout/LAYOUT_CLOSE'
export const LAYOUT_PROFILE = 'layout/LAYOUT_PROFILE'
export const LAYOUT_IS_OPENED = 'layout/LAYOUT_IS_OPENED'
export const LAYOUT_NOTIFICATIONS = 'layout/LAYOUT_NOTIFICATIONS'
export const LAYOUT_PROFILE_CLOSE = 'layout/LAYOUT_PROFILE_CLOSE'
export const LAYOUT_NOTIFICATIONS_CLOSE = 'layout/LAYOUT_NOTIFICATIONS_CLOSE'
export const IS_FETCHING_CAMPAIGNS = 'layout/IS_FETCHING_CAMPAIGNS'

/**
 * Tipos da Store de Prateleiras.
 */
export const SHELVES = 'shelf/SHELVES'
export const SHELF_PARTNER = 'shelf/SHELF_PARTNER'
export const SHELF_HIGHLIGHT = 'shelf/SHELF_HIGHLIGHT'
export const SHELVES_CATEGORIES = 'shelf/SHELVES_CATEGORIES'
export const SHELVES_WITH_CAMPAIGNS = 'shelf/SHELVES_WITH_CAMPAIGNS'
export const SHELVES_FILTERED = 'shelf/SHELVES_FILTERED'

/**
 * Tipos da Store de Awards.
 */
export const AWARDS_SHELF = 'awards/AWARDS_SHELF'
export const GET_AWARDS_LIST = 'awards/GET_AWARDS_LIST'
export const GET_AWARDS_INCREASE = 'awards/GET_AWARDS_INCREASE'
export const AWARDS_LIST = 'awards/AWARDS_LIST'
export const AWARDS_OPTIONS = 'awards/AWARDS_OPTIONS'
export const FIND_AWARD_PARTNER = 'awards/FIND_AWARD_PARTNER'
export const AWARD_RESCUE = 'awards/AWARD_RESCUE'
export const AWARD_TRANSACTIONS = 'awards/AWARD_TRANSACTIONS'

/**
 * Tipos da Store de Notices.
 */
export const NOTICE = 'notices/NOTICE'
export const NOTICE_CLICK = 'notices/NOTICE_CLICK'

/**
 * Tipos da Store de Campanhas.
 */
export const CAMPAIGN = 'campaign/CAMPAIGN'
export const CAMPAIGN_LIKE = 'campaign/CAMPAIGN_LIKE'
export const CAMPAIGN_GET_LINK = 'campaign/CAMPAIGN_GET_LINK'
export const CAMPAIGN_TRACKING = 'campaign/CAMPAIGN_TRACKING'
export const CAMPAIGN_EVENT_RESET = 'campaign/CAMPAIGN_EVENT_RESET'
export const CAMPAIGN_PAYMENT_FLAG = 'campaign/CAMPAIGN_PAYMENT_FLAG'
export const CAMPAIGN_FAVORITE = 'campaign/CAMPAIGN_FAVORITE'

/**
 * Tipos da Store de Banners.
 */
export const BANNERS = 'banner/BANNERS'
export const BANNERS_RESULT = 'banner/BANNERS_RESULT'
export const LAST_CATEGORY = 'banner/LAST_CATEGORY'
export const SCROLL_POSITION = 'banner/SCROLL_POSITION'

/**
 * Tipos da Store de Showcase.
 */
export const SHOWCASE_LIST = 'showcase/SHOWCASE_LIST'
export const SHOWCASE_INCREASE = 'showcase/SHOWCASE_INCREASE'
export const SHOWCASE_OPTIONS = 'showcase/SHOWCASE_OPTIONS'
export const SHOWCASE_INFO = 'showcase/SHOWCASE_INFO'

/**
 * Tipos da Store de Search.
 */
export const SEARCH = 'search/SEARCH'
export const SEARCH_CAMPAIGNS = 'search/SEARCH_CAMPAIGNS'
export const SEARCH_INFO = 'search/SEARCH_INFO'
export const SEARCH_TERM = 'search/SEARCH_TERM'
export const SEARCH_TERM_CLEAR = 'search/SEARCH_TERM_CLEAR'
export const SEARCH_OPTIONS = 'search/SEARCH_OPTIONS'
export const SEARCH_RESULTS = 'search/SEARCH_RESULTS'
export const SEARCH_INCREASE = 'search/SEARCH_INCREASE'
export const SEARCH_SUGGESTIONS = 'search/SEARCH_SUGGESTIONS'
export const SEARCH_FAVORITE_ADD = 'search/SEARCH_FAVORITE_ADD'
export const SEARCH_FAVORITE_REMOVE = 'search/SEARCH_FAVORITE_REMOVE'

/**
 * Tipos da Store de Suporte
 */
export const SUPPORT = 'support/SUPPORT'

/**
 * Tipos da Store de Filtro.
 */
export const FILTERS = 'filter/FILTERS'
export const FILTER_ORDINATOR = 'filter/FILTER_ORDINATOR'

/**
 * Tipos da Store de Usuário.
 */
export const USER = 'user/USER'
export const USER_LETTER = 'user/USER_LETTER'
export const USER_LETTER_VALID = 'user/USER_LETTER_VALID'
export const USER_EDIT = 'user/USER_EDIT'

/**
 * Tipos da Store de Experiência negativa.
 */
export const NEGATIVE_EXPERIENCE = 'negativeExperience/NEGATIVE_EXPERIENCE'
export const NEGATIVE_EXPERIENCE_TYPES = 'negativeExperience/NEGATIVE_EXPERIENCE_TYPES'

/**
 * Tipos da Store de Feedback.
 */
export const FEEDBACK = 'feedback/FEEDBACK'
export const FEEDBACK_CLOSE = 'feedback/FEEDBACK_CLOSE'

/**
 * Tipos da Store de Transações.
 */
export const TRANSACTIONS = 'transactions/TRANSACTIONS'
export const TRANSACTIONS_PAGINATION = 'transactions/TRANSACTIONS_PAGINATION'
export const GET_GIFT_CARD = 'transactions/GET_GIFT_CARD'

/**
 * Tipos da Store de Voucher.
 */
const VOUCHER = 'voucher/VOUCHER'
const VOUCHERS = 'voucher/VOUCHERS'
const VOUCHER_EXCLUDE = 'voucher/VOUCHER_EXCLUDE'
const VOUCHERS_PAGINATE = 'voucher/VOUCHERS_PAGINATE'
const VOUCHERS_INCREASE = 'voucher/VOUCHERS_INCREASE'

export {
  VOUCHER, VOUCHERS, VOUCHERS_PAGINATE,
  VOUCHER_EXCLUDE, VOUCHERS_INCREASE
}

/*
 *  Tipos da store de Favoritos
 */
const FAVORITES = 'favorite/FAVORITES'
const FAVORITE_ADD = 'favorite/FAVORITE_ADD'
const FAVORITE_REMOVE = 'favorite/FAVORITE_REMOVE'
const FAVORITE_CAMPAIGN = 'favorite/FAVORITE_CAMPAIGN'
const FAVORITES_SEARCH = 'favorite/FAVORITES_SEARCH'

export {
  FAVORITES, FAVORITE_ADD, FAVORITE_REMOVE,
  FAVORITE_CAMPAIGN, FAVORITES_SEARCH
}

/**
 * Tipos da store do breadcrumb.
 */
export const BREADCRUMB = 'breadcrumb/BREADCRUMB'
export const BREADCRUMB_CATEGORY = 'breadcrumb/BREADCRUMB_CATEGORY'
export const BREADCRUMB_NAMES = 'breadcrumb/BREADCRUMB_NAMES'
export const BREADCRUMB_ROUTES = 'breadcrumb/BREADCRUMB_ROUTES'

/**
 * Tipos da store do endereços.
 */
export const ADDRESS = 'address/ADDRESS'
export const ADDRESS_PAGINATE = 'address/ADDRESS_PAGINATE'
export const ADDRESS_PARAMS = 'address/ADDRESS_PARAMS'
export const ADDRESS_QUERY = 'address/ADDRESS_QUERY'

/**
 * Geolocation API
 */
export const USER_LOCATION = 'geolocation/USER_LOCATION'
export const PARTNERS_NEARBY = 'geolocation/PARTNERS_NEARBY'
export const SHELF_PARTNERS_NEARBY = 'geolocation/SHELF_PARTNERS_NEARBY'

/**
 * Tipos da store de parceiros.
 */
export const PARTNER_PAGINATION = 'partner/PARTNER_PAGINATION'

/**
 * Tipos da store de seja parceiro.
 */
export const BECOME_PARTNER = 'becomePartner/BECOME_PARTNER'

/**
 * Tipo da Store de Notifications.
 */
export const NOTIFICATIONS = 'notifications/NOTIFICATIONS'
export const GET_NOTIFICATIONS = 'notifications/GET_NOTIFICATIONS'
export const CAN_GET_NEW_NOTIFICATIONS = 'notifications/CAN_GET_NEW_NOTIFICATIONS'
export const NEW_NOTIFICATIONS = 'notifications/NEW_NOTIFICATIONS'
export const CHECK_NOTIFICATIONS = 'notifications/CHECK_NOTIFICATIONS'
export const MARK_NOTIFICATION_AS_READ = 'notifications/MARK_NOTIFICATION_AS_READ'

/**
 * Tipos da Store de Engajamento.
 */
export const ENGAGEMENT_PARTNER = 'engagement/ENGAGEMENT_PARTNER'
export const ENGAGEMENT_PARTNERS = 'engagement/ENGAGEMENT_PARTNERS'
export const ENGAGEMENT_CAMPAIGNS = 'engagement/ENGAGEMENT_CAMPAIGNS'
export const GET_ENGAGEMENT_CAMPAIGNS = 'engagement/GET_ENGAGEMENT_CAMPAIGNS'
export const GET_ENGAGEMENT_PARTNERS = 'engagement/GET_ENGAGEMENT_PARTNERS'
export const GET_ENGAGEMENT_INCREASE = 'engagement/GET_ENGAGEMENT_INCREASE'
export const ENGAGEMENT_OPTIONS = 'engagement/ENGAGEMENT_OPTIONS'
export const FIND_ENGAGEMENT_PARTNER = 'engagement/FIND_ENGAGEMENT_PARTNER'
export const ENGAGEMENT_RESCUE = 'engagement/ENGAGEMENT_RESCUE'
export const ENGAGEMENT_TRANSACTIONS = 'engagement/ENGAGEMENT_TRANSACTIONS'
export const ENGAGEMENT_BALANCE = 'user/ENGAGEMENT_BALANCE'
export const COIN = 'engagement/COIN'
export const GET_COIN = 'engagement/GET_COIN'

/**
 * Tipo da Store do Vidalink
 */
export const VIDALINK = 'vidalink/VIDALINK'

/**
 * Tipo da Store de Saques.
 */
export const WITHDRAW = 'withdraw/WITHDRAW'



// WEBPACK FOOTER //
// ./src/store/types.js